import { createSingleAction } from 'store/utils';

const SET_OPEN_COMPENSATION_CHANGE = 'employment_management/SET_OPEN_COMPENSATION_CHANGE';
export const setOpenCompensationChange = createSingleAction<
boolean,
typeof SET_OPEN_COMPENSATION_CHANGE
>(
    SET_OPEN_COMPENSATION_CHANGE,
);
